import { render } from "./template.html?vue&type=template&id=15d07cc2&scoped=true&ts=true&external"
import script from "./script.ts?vue&type=script&lang=ts&external"
export * from "./script.ts?vue&type=script&lang=ts&external"

import "./style.scss?vue&type=style&index=0&id=15d07cc2&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15d07cc2"]])

export default __exports__